import { render, staticRenderFns } from "./dictionary-item.vue?vue&type=template&id=4e0614a8&scoped=true&"
import script from "./dictionary-item.vue?vue&type=script&lang=js&"
export * from "./dictionary-item.vue?vue&type=script&lang=js&"
import style0 from "./dictionary-item.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./dictionary-item.vue?vue&type=style&index=1&id=4e0614a8&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0614a8",
  null
  
)

export default component.exports